import { updateObject } from "utils/helpers/updateObject";
import { FetchQuestionsRequestAction, FetchQuestionsSuccessAction, stateStatusType, FetchQuestionsFailureAction, QuestionsActions, actionTypes, CreateQuestionRequestAction, CreateQuestionSuccessAction, CreateQuestionFailAction, UpdateQuestionRequestAction, UpdateQuestionSuccessAction, UpdateQuestionFailAction, UpdateQuestionPublishedStatusRequestAction, UpdateQuestionPublishedStatusSuccessAction, UpdateQuestionPublishedStatusFailAction, DeleteQuestionRequestAction, DeleteQuestionSuccessAction, DeleteQuestionFailAction } from "./actionType";
import { initialState, QuestionsState } from "./state";

//FetchQuestionssRequest
const FetchQuestionsRequest = (
  state: QuestionsState,
  action: FetchQuestionsRequestAction
) => {
  return updateObject(state, {
    questionsState: {
      ...state.questionsState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const FetchQuestionsSuccess = (
  state: QuestionsState,
  action: FetchQuestionsSuccessAction
) => {
  return updateObject(state, {
    questionsState: {
      ...state.questionsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      questions: action.payload,
    },
  });
};

const FetchQuestionsFail = (
  state: QuestionsState,
  action: FetchQuestionsFailureAction
) => {
  return updateObject(state, {
    questionsState: {
      ...state.questionsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      questions: null,
    },
  });
};

//create season
const CreateQuestionsRequest = (
  state: QuestionsState,
  action: CreateQuestionRequestAction
) => {
  return updateObject(state, {
    questionsState: {
      ...state.questionsState,
      isLoading: true,
      error: null,
      questions: null,
    },
  });
};
const CreateQuestionsSuccess = (
  state: QuestionsState,
  action: CreateQuestionSuccessAction
) => {
  const newQuestion = state.questionsState.questions ?? [];
  return updateObject(state, {
    genericQuestionsState: {
      ...state.genericQuestionsState,
      isLoading: false,
      error: null,
       state: stateStatusType.SUCCESS,
       question:action.payload
    },
    questionsState: {
      ...state.questionsState,
      isLoading: false,
      error: null,
      state: stateStatusType.SUCCESS,
      questions: [...newQuestion, ...action.payload],
    },
  });
};
const CreateQuestionsFail = (
  state: QuestionsState,
  action: CreateQuestionFailAction
) => {
  return updateObject(state, {
    genericQuestionsState: {
      ...state.genericQuestionsState,
      isLoading: false,
      state: stateStatusType.FAILED,
    },
    questionsState: {
      ...state.questionsState,
      isLoading: false,
      error: action.payload,
      state: stateStatusType.FAILED,
    },
  });
};

//Update question
const UpdateQuestionRequest =( state: QuestionsState, action: UpdateQuestionRequestAction) => {
  return updateObject(state, {
    genericQuestionsState: {
      ...state.genericQuestionsState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const UpdateQuestionSuccess = (
  state: QuestionsState,
  action: UpdateQuestionSuccessAction
) => {
  const updatedQuestions = state.questionsState.questions?.map((question) =>
    question.id === action.payload.id ? action.payload : question
  ) || [];
  return updateObject(state, {
    questionsState: {
      ...state.questionsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      questions: [...updatedQuestions],
    },

  });
}

const UpdateQuestionFail = (
  state: QuestionsState,
  action: UpdateQuestionFailAction
) => {
  return updateObject(state, {
    genericQuestionsState: {
      ...state.genericQuestionsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

//update question published status
const UpdateQuestionPublishedStatusRequest = (
  state: QuestionsState,
  action: UpdateQuestionPublishedStatusRequestAction) => {
  return updateObject(state, {
    genericQuestionsState: {
      ...state.genericQuestionsState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const UpdateQuestionPublishedStatusSuccess = (
  state: QuestionsState,
  action: UpdateQuestionPublishedStatusSuccessAction
) => {
  const updatedQuestions = state.questionsState.questions?.map((question) => {
    if (question.id === action.payload.id) {
      return {
        ...question,
        is_published: action.payload.is_published,
      };
    }
    return question;
  }) || [];

  return updateObject(state, {
    questionsState: {
      ...state.questionsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      questions: updatedQuestions,
    },
  });
};




const UpdateQuestionPublishedStatusFail = (
  state: QuestionsState,
  action: UpdateQuestionPublishedStatusFailAction) => {
  return updateObject(state, {
    genericQuestionsState: {
      ...state.genericQuestionsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
}

//delete question
const DeleteQuestionRequest = (
  state: QuestionsState,
  action: DeleteQuestionRequestAction) => {
  return updateObject(state, {
    questionsState: {
      ...state.questionsState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};
const DeleteQuestionSuccess = (
  state: QuestionsState,
  action: DeleteQuestionSuccessAction) => {
  const filteredQuestions = state.questionsState.questions?.filter((question) => String(question.id) !== String(action.payload)) || [];
  return updateObject(state, {
    questionsState: {
      ...state.questionsState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      questions: [...filteredQuestions],
    },
  });
};  

const DeleteQuestionFail = (
  state: QuestionsState,
  action: DeleteQuestionFailAction
) => {
  return updateObject(state, {
    genericQuestionsState: {
      ...state.genericQuestionsState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

const QuestionssReducer = (
  state = initialState,
  action: QuestionsActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_QUESTIONS_REQUEST:
      return FetchQuestionsRequest(state, action);
    case actionTypes.FETCH_QUESTIONS_SUCCESS:
      return FetchQuestionsSuccess(state, action);
    case actionTypes.FETCH_QUESTIONS_FAIL:
      return FetchQuestionsFail(state, action);
    case actionTypes.CREATE_QUESTION_REQUEST:
      return CreateQuestionsRequest(state, action);
    case actionTypes.CREATE_QUESTION_SUCCESS:
      return CreateQuestionsSuccess(state, action);
    case actionTypes.CREATE_QUESTION_FAIL:
      return CreateQuestionsFail(state, action);
    case actionTypes.UPDATE_QUESTION_REQUEST:
      return UpdateQuestionRequest(state, action);
    case actionTypes.UPDATE_QUESTION_SUCCESS:
      return UpdateQuestionSuccess(state, action);
    case actionTypes.UPDATE_QUESTION_FAIL:
      return UpdateQuestionFail(state, action);
    case actionTypes.UPDATE_QUESTION_PUBLISED_STATUS_REQUEST:
      return UpdateQuestionPublishedStatusRequest(state, action);
    case actionTypes.UPDATE_QUESTION_PUBLISED_STATUS_SUCCESS:
      return UpdateQuestionPublishedStatusSuccess(state, action);
    case actionTypes.UPDATE_QUESTION_PUBLISED_STATUS_FAIL:
      return UpdateQuestionPublishedStatusFail(state, action);
    case actionTypes.DELETE_QUESTION_REQUEST:
      return DeleteQuestionRequest(state, action);
    case actionTypes.DELETE_QUESTION_SUCCESS:
      return DeleteQuestionSuccess(state, action);
    case actionTypes.DELETE_QUESTION_FAIL:
      return DeleteQuestionFail(state, action);
    default:
      return state;
  }
};

export default QuestionssReducer;